const isInDev = process.env.NODE_ENV === "development";
export const isCampionat = false;

export const showToa = () => isInDev || isCampionat;
export const showEntrenos = () => isInDev;
export const showUser = () => isInDev;
